import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { Error } from "components/PlanSetup/styles";
import { colors, theme } from "theme";
import { Wrapper } from "./styles";
import { formatToIndianSystem, formatToRupees } from "utlis/utils";
import _get from "lodash/get";
import { Ptag } from "../fonts";

const BaseInput = ({
  label,
  customValue,
  disabled,
  variant,
  formikProps,
  type,
  formatToRupee,
  fontSize,
  labelFontSize,
  applyParseFloat = false,
  phone,
  date,
  pincode,
  placeholder,
  staticLabel,
  phoneTpa,
  formatToIndianNumbering,
  disableUnderline,
  onKeyDown,
  onKeyPress,
  onPaste,
  onInput,
  inputProps,
  staticLabelStyle,
  preventSpaces
}) => {
  const { values, handleChange, name, errors, touched } = formikProps;
  const [formatValue, setFormatValue] = useState("");
  const errorValue = getNestedValue(errors || {}, name);
  const touchedValue = getNestedValue(touched || {}, name);

  useEffect(() => {
    if (customValue && _get(values, customValue) === "") setFormatValue("");
    if (values && values[name] === "") setFormatValue("");
  }, [values, name, customValue]);

  function getNestedValue(obj, path, context = {}) {
    // First, dynamically replace context variables if any
    const resolvedPath = path.replace(
      /\[\$(.*?)\]/g,
      (match, p1) => `[${context[p1]}]`
    );

    // Split the path into parts considering the array indices followed directly by property names
    const parts = resolvedPath.split(/\.|\[(?=\d+\])|\](?=\w)/).filter(Boolean);

    return parts.reduce((acc, part) => {
      // Normalize array access and property names
      const normalizedPart = part.replace(/[[\]']+/g, "");
      return acc && acc[normalizedPart] !== undefined
        ? acc[normalizedPart]
        : undefined;
    }, obj);
  }
  useEffect(() => {
    // Update formatValue when formik values change, but only if it's different
    const currentValue = getNestedValue(values, name);
    if (applyParseFloat && values.grade_code) {
      setFormatValue(currentValue);
    } else {
      setFormatValue(currentValue !== null && currentValue !== undefined && currentValue !== "" ? currentValue : "");
    }
  }, [values, name, applyParseFloat]);

  const handleChangeAmount = (e) => {
    // setPatch(false);
    if (formatToRupee) {
      const value = formatToRupees(e.target.value);
      handleChange && handleChange(e);
      setFormatValue(value);
    } else if (phone) {
      if (e.target.value.length <= 10) {
        const value = e.target.value;
        const regex = /^[0-9\b]+$/;
        if (value === "" || regex.test(value)) {
          handleChange && handleChange(e);
          setFormatValue(value);
        }
      }
    } else if (formatToIndianNumbering) {
      const newVal = formatToIndianSystem(e.target.value);
      e.target.value = newVal;
      handleChange && handleChange(e);
      setFormatValue(newVal);
    } else if (phoneTpa) {
      if (e.target.value.length <= 10) {
        const value = e.target.value;
        const regex = /^[0-9\b]+$/;
        if (value === "" || regex.test(value)) {
          handleChange && handleChange(e);
          setFormatValue(value);
        }
      }
    } else if (pincode) {
      if (e.target.value.length <= 6) {
        const value = e.target.value;
        const regex = /^[0-9\b]+$/;
        if (value === "" || regex.test(value)) {
          handleChange && handleChange(e);
          setFormatValue(value);
        }
      }
    } else if (date) {
      let newDate = e.target.value;
      let prevDateLen = values[name].length;
      let newDateLen = newDate.length;
      let newDob = newDate;

      if (newDateLen < prevDateLen) {
        newDob = values[name].substr(0, prevDateLen - 1);
      } else if (newDateLen <= 10) {
        if (newDateLen === 2 || newDateLen === 5) {
          newDob = newDate + "/";
        }
      } else {
        newDob = newDate.slice(0, 10);
      }
      // regex to enable digit and / only
      const regex = /^[0-9\b/]+$/;
      if (newDob === "" || regex.test(newDob)) {
        handleChange && handleChange(e);
        setFormatValue(newDob);
      }
    } else if (preventSpaces) {
      const newVal = e.target.value.replace(/\s/g, "");
      e.target.value = newVal;
      handleChange && handleChange(e);
      setFormatValue(newVal);
    } else {
      // For regular text inputs, always allow the change
      handleChange && handleChange(e);
      setFormatValue(e.target.value);
    }
  };
  return (
    <Wrapper>
      {staticLabel && (
        <span id="static-label">
          <Ptag
            color={colors.primaryColor}
            style={{ 
              fontSize: "14px !important", 
              marginTop: staticLabelStyle?.marginTop !== undefined ? staticLabelStyle.marginTop : '6px' 
            }}
            marginBottom="10px"
          >
            {staticLabel}
          </Ptag>
        </span>
      )}
      <TextField
        InputProps={{
          disableUnderline: disableUnderline,
          style: {
            borderRadius: disableUnderline ? "10px" : "inherit",
            overflow: disableUnderline ? "hidden" : "inherit",
          },
          ...inputProps
        }}
        disabled={disabled}
        sx={{
          fontSize: "100%",
          width: "100%",
          fontFamily: "Inter",
          marginBottom: "7px",
          "& fieldset": {
            borderColor: `${errorValue && touchedValue ? "red" : theme.primaryColor} !important`,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
          },
          "& input": {
            fontSize: `${fontSize ? fontSize.replace(' !important', '') : "12px"} !important`,
            fontFamily: "Inter",
            color: colors.primaryColor,
            padding: "12.5px",
          },
          "& label": {
            fontSize: `${labelFontSize ? labelFontSize.replace(' !important', '') : (fontSize ? fontSize.replace(' !important', '') : "14px")} !important`,
            fontFamily: "Inter",
            width: "400px",
          },
        }}
        label={label}
        placeholder={placeholder}
        variant={variant ? variant : "outlined"}
        value={formatValue}
        name={name}
        type={type || "text"}
        onChange={handleChangeAmount}
        onKeyDown={onKeyDown}
        onKeyPress={onKeyPress}
        onPaste={onPaste}
        onInput={onInput}
        autoComplete="off"
      />
      {errorValue && touchedValue && <Error>{errorValue}</Error>}
    </Wrapper>
  );
};

export default BaseInput;